<ng-template #tooluploadDialogTemplate>
    <div *ngIf="isWaiting && !vnaUploadExternalData.type" class="estensa-spinner">
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!vnaUploadExternalData.type && !isWaiting" class="vna-dilaog-container">
        <h3 class="se-dialog-header se-flex" style="margin:0;" mat-dialog-title>{{toolbarAction | translate}}</h3>
        <toolupload-form class="container-main-tool-vna-notdicom" [vnaUploadExternalData]="vnaUploadExternalData" (closeModalEvent)="closeModal()"></toolupload-form>
    </div>
    <div *ngIf="vnaUploadExternalData.type" class="vna-dilaog-dicom-container">
        <h3 class="se-dialog-header se-flex" style="margin:0;" mat-dialog-title>{{toolbarAction | translate}}</h3>
        <dicom-landing-page [originPage]="vnaUploadExternalData.from" [patientDetails]="patientDetails"></dicom-landing-page>
        <div class="button-dicom-container-vna-dialog">
            <button (click)="closeModal()" color="primary" id="close-dicom"
                    mat-button
                    mat-dialog-close
                    style="font-size:1em; margin:3px"
                    type="button">
                <p style="margin:0" translate>Close</p>
            </button>
        </div>
    </div>
</ng-template>

